module.exports = __webpack_public_path__ + "static/fonts/Gilroy-Extrabold.de08bd32.otf";